export enum FilterDate {
  LAST_YEAR,
  LAST_MONTH,
  LAST_WEEK,
  ALWAYS,
}
